import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl,Input } from '@material-ui/core';
import { Button } from 'components';
import styles from './Form.scss';

const Form = ({ assistiveTextLabels, assistiveTextContent, onUpdateText, close }) => {
    const [assistiveText, setAssistiveText] = useState(assistiveTextContent);

    const onChangeText = (key, value) => {
        const updatedText = {
            ...assistiveText,
            [key]: value
        };
        setAssistiveText(updatedText);
    };

    const handleSave = () => {
        onUpdateText(assistiveText);
        close();
    };

    return (
        <div className={styles.container}>
            <form>
                <FormControl className={styles.formField}>
                    <label
                        htmlFor='assistive-text-title'
                        className={styles.label}
                    >
                        { assistiveTextLabels.title }
                    </label>
                    <Input
                        id='assistive-text-title'
                        fullWidth
                        value={assistiveText.title}
                        onChange={(event) => onChangeText('title', event.target.value)}
                    />
                </FormControl>
                <FormControl className={styles.formField}>
                    <label
                        htmlFor='assistive-text-description'
                        className={styles.label}
                    >
                        { assistiveTextLabels.description }
                    </label>
                    <Input
                        id='assistive-text-description'
                        fullWidth
                        value={assistiveText.description}
                        multiline
                        onChange={(event) => onChangeText('description', event.target.value)}
                    />
                </FormControl>
                <FormControl className={styles.buttonsContainer}>
                    <Button
                        className={styles.closeButton}
                        onClick={close}
                    >
                        { assistiveTextLabels.close }
                    </Button>
                    <Button
                        onClick={handleSave}
                        className={styles.saveButton}
                    >
                        { assistiveTextLabels.save }
                    </Button>
                </FormControl>
            </form>
        </div>
    )
}

Form.propTypes = {
    assistiveTextLabels: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        close: '',
        save: ''
    }),
    assistiveTextContent: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
    }),
    onUpdateText: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
}

Form.defaultProps = {
    assistiveTextLabels: {
        title: 'Title',
        description: 'Description',
        close: 'Close',
        save: 'Save'
    },
    assistiveTextContent: { title: '', description: '' }
};

export default Form
